import { createCollectInfoContainer } from '@anm/helpers/createCollectInfoContainer';

export const [collectAuthInfo, flushAuthInfo] = createCollectInfoContainer(
  'auth'
);
